import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Métrica plana: etiqueta + cifra tabular grande sobre fondo blanco (reemplaza las
 * cards de vidrio sobre foto de `sales-stats`). Con `interactive`, es un botón
 * nativo con chevron que emite `pressed`.
 */
@Component({
  selector: 'app-flat-stat',
  templateUrl: './flat-stat.component.html',
  styleUrls: ['./flat-stat.component.scss'],
  standalone: false,
})
export class FlatStatComponent {
  /** Clave de traducción de la etiqueta. */
  @Input({ required: true }) labelKey!: string;
  /** Valor ya formateado (para montos, pasarlo por `arsCurrency`). */
  @Input({ required: true }) value!: string | number;
  @Input() interactive = false;
  @Output() pressed = new EventEmitter<void>();
}
